import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Component, OnInit, TemplateRef, ViewChild, Input} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {ToasterService} from 'angular2-toaster';

import {LOCALE_CONFIG} from '@common-lib';
import {PluginGotenehusMappingService, PluginGotenehusMappingDataService} from '../../pages-services';

@Component({
    selector: 'app-sync-button',
    templateUrl: 'sync-button.component.html',
    styleUrls: ['sync-button.component.scss']
})
export class SyncButtonComponent implements OnInit {
    @Input() selectedLocale = LOCALE_CONFIG.DEFAULT_LOCALE;
    @Input() tablesToSync: any[] = [];

    isSyncing = false;
    tables = [];

    syncModalRef: BsModalRef;

    @ViewChild('syncFormTemplate')
    syncFormTemplate: TemplateRef<any>;

    constructor(
        private modalService: BsModalService,
        private pluginGotenehusMappingDataService: PluginGotenehusMappingDataService,
        private translateService: TranslateService,
        private toasterService: ToasterService
    ) {

    }

    ngOnInit() {
        this.tables  = [
            {
                name: 'variants',
                title: 'Variants'
            }, {
                name: 'plugin_gotenehus_product_regions',
                title: 'PG Product Regions'
            }
        ];
    }

    openSyncDialog() {
        this.syncModalRef = this.modalService.show(this.syncFormTemplate);
    }

    closeSyncDialog() {
        this.syncModalRef.hide();
    }

    async syncData() {
        this.isSyncing = true;

        this.pluginGotenehusMappingDataService.syncData(this.tablesToSync).subscribe(async response => {
            this.syncModalRef.hide();
            this.isSyncing = false;
            const successMessage = await this.translateService.get('webpanel.plugin_gotenehus_mapping_data.updated_message').toPromise();
            this.toasterService.pop('success', '', successMessage);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/sync-button/sync-button.component.ts